export default __webpack_public_path__ + "static/media/REAL YIELD PROTOCOL.ebf5d500.svg";